import { ValidationModel } from '@max/shared/models/validation-results/validation.model';

export class DisbursementFuelTaxRequestDenialReasonModel extends ValidationModel {

    // Gets or sets the disbursement fuel tax request denial reason id
    public id: number;

    // Gets or sets the disbursement fuel tax request id
    public financeDisbursementFuelTaxRequestId: number;

    // Gets or sets the disbursement fuel tax request denial reason type id
    public financeDisbursementFuelTaxRequestDenialReasonTypeId: number;

    // Gets or sets the disbursement fuel tax request denial reason type
    public financeDisbursementFuelTaxRequestDenialReasonType: string;

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.id = json.id;
            this.financeDisbursementFuelTaxRequestId = json.financeDisbursementFuelTaxRequestId;
            this.financeDisbursementFuelTaxRequestDenialReasonTypeId = json.financeDisbursementFuelTaxRequestDenialReasonTypeId;
            this.financeDisbursementFuelTaxRequestDenialReasonType = json.financeDisbursementFuelTaxRequestDenialReasonType;
        }
    }
}
